import { Input } from "semantic-ui-react";

export default [
  [
    {
      name: "name",
      label: "Name",
      placeHolder: "",
      readOnly: true,
      control: Input,
    },
    
    {
      name: "surname",
      label: "Surname",
      placeHolder: "",
      readOnly: true,
      control: Input,
    },
    {
      name: "email",
      label: "Email",
      placeHolder: "",
      readOnly: true,
      control: Input,
    },
  ],
  [
    {
      name: "office",
      label: "Office",
      placeHolder: "",
      readOnly: true,
      control: Input,
    },
    {
      name: "company_name",
      label: "Company Name",
      placeHolder: "",
      readOnly: true,
      control: Input,
    },
  ],
  [
    // {
    //   name: "hierarchical_node",
    //   label: "Hierarchical Node",
    //   placeHolder: "",
    //   readOnly: true,
    //   control: Input,
    // },
    {
      name: "name_pm",
      label: "People Manager",
      placeHolder: "",
      readOnly: true,
      control: Input,
    },
    // {
    //   name: "division_name",
    //   label: "Division Name",
    //   placeHolder: "",
    //   readOnly: true,
    //   control: Input,
    // },
    // {
    //   name: "name_pm",
    //   label: "Practice Manager",
    //   placeHolder: "",
    //   readOnly: true,
    //   control: Input,
    // },
    {
      name: "business_title",
      label: "Business Title",
      placeHolder: "",
      readOnly: true,
      control: Input,
    },
  ]
];
